import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property } from 'lit/decorators.js';
import { InternalI18n } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/i18n/internal-i18n-controller.js';
import { emit } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/event.js';
import '@cigna/cigna_csg_gsg_cipublic-icon/cipublic-icon.js';
import '@cigna/cigna_csg_gsg_cipublic-button/cipublic-button.js';
import styles from './share-button.scss.js';
import { locales } from './locales.js';
/**
 * @element cipublic-share-button
 *
 * TODO:
 * - Implement localization for aria-label
 *
 * @fires sharebutton.notsupported
 * @fires sharebutton.failed
 */
export class ShareButton extends CipublicElement {
    constructor() {
        super(...arguments);
        this.i18n = new InternalI18n(this, locales);
        /**
         * The link-list background color.
         */
        this.text = 'alternate';
        /**
         * Constructor name.
         */
        this._name = 'sharebutton';
    }
    static get styles() {
        return [styles];
    }
    firstUpdated(changedProperties) {
        super.firstUpdated(changedProperties);
        if (!('share' in navigator)) {
            this.hidden = true;
            emit(this, `${this._name}.notsupported`);
        }
    }
    triggerWebShare() {
        var _a;
        navigator
            .share({
            title: document.title,
            text: (_a = document.querySelector('meta[name="description"]')) === null || _a === void 0 ? void 0 : _a.content,
            url: location.href,
        })
            .catch((error) => {
            emit(this, `${this._name}.failed`, { detail: { error } });
        });
    }
    render() {
        return html `<slot name="heading"></slot><cipublic-button @click="${this.triggerWebShare}" icononly="" size="default" type="button" variant="secondary"><cipublic-icon set="system" name="share" aria-label="${this.i18n.t('sharebutton_aria')}" role="img"></cipublic-icon></cipublic-button>`;
    }
}
__decorate([
    property({ reflect: true })
], ShareButton.prototype, "text", void 0);
//# sourceMappingURL=share-button.js.map